export default "__VITE_ASSET__02696131__"